import { inject, injectable } from "inversify";
import {
  ICPLCaseStatusTypesClient,
  IntSelectModel,
  CaseStatusTypeModel,
  NewCaseStatusTypeModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ICaseStatusTypesService {
  getCaseStatusTypes(): Promise<CaseStatusTypeModel[]>;
  createCaseStatusType(newCaseStatusTypeModel: NewCaseStatusTypeModel): Promise<void>;
  updateCaseStatusType(caseStatusTypeModel: CaseStatusTypeModel): Promise<void>;
  deleteCaseStatusType(caseStatusTypeID: number): Promise<void>;
  getCaseStatusTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class CaseStatusTypesService implements ICaseStatusTypesService {
  @inject(SERVICE_TYPES.CPLCaseStatusTypesClient)
  cplCaseStatusTypesClient!: ICPLCaseStatusTypesClient;

  async getCaseStatusTypes(): Promise<CaseStatusTypeModel[]> {
    return this.cplCaseStatusTypesClient.getCaseStatusTypes();
  }

  async createCaseStatusType(newCaseStatusTypeModel: NewCaseStatusTypeModel): Promise<void> {
    return this.cplCaseStatusTypesClient.createCaseStatusType(newCaseStatusTypeModel);
  }

  async updateCaseStatusType(caseStatusTypeModel: CaseStatusTypeModel): Promise<void> {
    return this.cplCaseStatusTypesClient.updateCaseStatusType(caseStatusTypeModel);
  }

  async deleteCaseStatusType(caseStatusTypeID: number): Promise<void> {
    return this.cplCaseStatusTypesClient.deleteCaseStatusType(caseStatusTypeID);
  }

  async getCaseStatusTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplCaseStatusTypesClient.getCaseStatusTypeSelectModels();
  }
}
